// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:09:21+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            8fec4ad4fe5c5b767d4627a91fe42ccd
//    Signature:      eyJpdiI6IjhVTnhEWDUyT0poaWZQQ2RhYldmRkE9PSIsInZhbHVlIjoiWTI4cGhiOFNBUE8wdE10eGtcL1VnR0lFdDhiVSs5ME40UCtQdDVMXC9cL29JZURxR3M4cVcwOUJXQzY0YkkzU3g4eFdBT0padmF0Mm8xZHF2TjRkeU8rcFA0eTBkelRvV3l3blwvWit6ZXgyM1JDdEFTREM1SVFvRUsyMTNDY0UzU2VHM1QrYVByeVFHUzhyaUN0S3YwUk56eFowZytZcGtuRHU5d0tGVFo2M2ZBVFFjSXd4OVh4WVpoSVI1WnBlN1hzMnU2K3FhWGJyeTBSMzExZk1idE9sU0hQdFE2cVpaNXUrTDA5d3pDK2FYUTczbkVSam1YU2w4UzBUT3NDRjVkT3FhWDBoamgycmlpSEMwSGtFZnhFNVlUb0VSbWxDYjJ2QlNoYXVhbnNodlVYXC9MQUpcL2JEV2hEZ1lUQ2l6WFVkOThPV2xIT0tleW1tYklCejVKTnQyM0RYd3V1U25TcnBMM0VDUW9JSVRUUU5YaWJvTWp1OFM5akR6Q0FVQllwaExSWER2ckFxRXpEQjBRdzhRYktjRGJGd3dDdWR6V2ZIMWQ3Vm9BY2Jtck5tST0iLCJtYWMiOiJiMzRmYzBlZGQ4MTk4YjU0NDcyZDZjNGQ4ZTY5YjEwMzZiN2QxMDg3NDUyMDMyMWQzNWE0YzVkOGRjOTcwYWIzIn0=
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
